import React, { useState } from "react";
import { Modal, Button, Row } from "antd";
import "./guest-warning-modal.scss"; // Add your styling here
import warningImage from "../assets/images/guest-warning-img.svg"
import infoIcon from "../assets/images/undraw_business_deal_re_up4u 1.svg"
import blockWarningIcon from "../assets/images/block_warning_modal.svg"
import { useNavigate } from "react-router-dom";

export const GuestWarningContainer = (t) => {
    const navigate = useNavigate();
    const loginNowHandler = () => {
      navigate("/login");
      localStorage.removeItem("guestMode");
    };

    return (
        <>
            <div className="modal-container-account">
            <img src={warningImage} alt="warning" className="modal-image" />

            <span className="modal-title">
                {t("LOGIN_UNLOCK_MSG")}
            </span>

            <div className="guest-buttons">
                {/* <Button type="secondary" className="cancel-btn">Cancel</Button> */}
                <Button type="secondary" className="login-now-btn" onClick={loginNowHandler}>{t("LOGIN_NOW_BTN")}/{t("SIGNUP_NOW_BTN")}</Button>
            </div>
            </div>
        </>
    );
};

export const GuestWarningModal = (navigate,t) => {
    const loginNowHandler = () => {
      Modal.destroyAll()
      navigate("/login");
      localStorage.removeItem("guestMode");
    };
    
    Modal.confirm({
          title:(<div className="guest-title">{t("LOGIN_NEEDED_TITLE")}</div>),
          icon: null,
          centered: true,
          closable: true,
          maskClosable: true,
          width: 500,          
          content: (
            <div className="modal-container">
              <img src={warningImage} alt="warning" className="modal-image" />
              <span className="modal-title">{"Login to unlock personalized experience"}</span>
            </div>
          ),
          footer: (
            <div className="guest-modal-button">
              <Button type="secondary" onClick={() => Modal.destroyAll()} className="guest-cancel-btn">
                {t("COMMON_CANCEL_BTN")}
              </Button>
              <Button type="secondary" onClick={loginNowHandler} className="guest-login-now-btn">
               {t("LOGIN_NOW_BTN")}
              </Button>
            </div>
          ),
        })

};

export const PendingStatusModal = (page, user, navigate,t) => {
   const okHandler = () => {
    Modal.destroyAll()
  };

  const navigateHandler = () => {
    Modal.destroyAll()
    navigate("/account")
  };

  Modal.confirm({
        title:(<div className="guest-title">{(user?.status === "DetailsPending" && page === "login") ? t("SUPPLIER_DETAILS_SUBMITTED_HOME_HDR")+' '+`${user.userName}` : (user?.status === "DetailsPending" && page !== "login") ? t("SUPPLIER_DETAILS_SUBMITTED_HDR") :(user?.status === "Banned") ? t("SUPPLIER_BANNED_HDR") : t("SUPPLIER_DETAILS_PENDING_HDR")}</div>),
        icon: null,
        centered: true,
        closable: true,
        maskClosable: true,
        width: 550,          
        content: (
          <div className="modal-container">
          {page === "login" ? (
            <div className="info-message">
              <img src={infoIcon} alt="" />
              {user?.status === "DetailsPending" ?
                <span style={{fontSize:"15px"}}>{t("SUPPLIER_DETAILS_PENDING_MSG")} <strong className="click-here" onClick={navigateHandler}> {t("CLICK_HERE_LBL")}</strong></span>:
                user?.status === "Banned" ?
                <span style={{fontSize:"15px"}}>{t("SUPPLIER_BANNED_MSG")}</span>
               :
                <span style={{fontSize:"15px"}}>{t("SUPPLIER_DETAILS_SUBMITTED_HOME_MSG")}</span>
              }
            </div>
          )
          : 
          (user?.status === "DetailsPending" ? 
            <span style={{fontSize:"15px"}}>{t("SUPPLIER_DETAILS_PENDING_MSG")} <strong className="click-here" onClick={navigateHandler}> {t("CLICK_HERE_LBL")}</strong></span>:
            user?.status === "Banned" ?
            <span style={{fontSize:"15px"}}>{t("SUPPLIER_BANNED_MSG")}</span>
            :
            <span style={{fontSize:"15px"}}>{t("SUPPLIER_DETAILS_SUBMITTED_MSG")}</span>
          )
          }
          </div>
        ),
        footer: (
          <div className="guest-modal-button">
            <Button type="secondary" onClick={okHandler} className="pending-login-now-btn">
              {t("COMMON_OK_BTN")}
            </Button>
          </div>
        ),
      })
};

export const BlockWarningModal = (navigate,t) => {
    const updateHandler = () => {
      Modal.destroyAll()
      navigate("/account");
    };
    
    Modal.confirm({
          title:(<div className="block-title">{t("BLOCKED_WARNING_TITLE")}</div>),
          icon: null,
          centered: true,
          closable: true,
          maskClosable: true,
          width: 500,          
          content: (
            <div className="block-modal-container">
              <span className="image-tag"><img src={blockWarningIcon} alt="warning" className="modal-image" /></span>
              <span className="modal-content">{t("BLOCKED_WARNING_MSG_FIRST_LINE")}</span>
              <span className="modal-content">{t("BLOCKED_WARNING_MSG_SECOND_LINE")}</span>            
            </div>
          ),
          footer: (
            <div className="guest-modal-button">
              <Button type="secondary" onClick={updateHandler} className="update-now-btn">
               {/* {t("UPGRADE_NOW_BTN")} */}
               Update Now
              </Button>
            </div>
          ),
        })

};

  